"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var date_fns_1 = require("date-fns");
var useTableData = function (history, settings) {
    if (history === void 0) { history = []; }
    var t = (0, next_intl_1.useTranslations)('lottery');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var formatCurrency = (0, swr_hooks_1.useCurrencyFormat)();
    var settingsPerCurrency = (0, react_1.useMemo)(function () { return settings === null || settings === void 0 ? void 0 : settings.find(function (item) { return item.currency === currentCurrency; }); }, [settings, currentCurrency]);
    var preparedHistory = (0, react_1.useMemo)(function () {
        return history.reduce(function (acc, item) {
            var _a;
            return __assign(__assign({}, acc), (_a = {}, _a[item.initiatorId ? String(item.initiatorId) : item.createdAt] = item, _a));
        }, {});
    }, [history]);
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'dateAndTime',
                    label: t('dateAndTime'),
                },
                {
                    field: 'deposit',
                    label: t('deposit'),
                },
                {
                    field: 'ticketPrice',
                    label: t('ticketPrice'),
                },
                {
                    field: 'ticketsEarned',
                    label: t('ticketsEarned'),
                },
            ],
            rows: [],
        };
        table.rows = Object.keys(preparedHistory).map(function (key) {
            var item = preparedHistory === null || preparedHistory === void 0 ? void 0 : preparedHistory[key];
            if (!(item === null || item === void 0 ? void 0 : item.depositAmount))
                return null;
            return {
                dateAndTime: (react_1.default.createElement("span", null, (0, date_fns_1.format)(new Date(item.createdAt), 'yyyy-LL-dd HH:mm'))),
                deposit: react_1.default.createElement("span", null, formatCurrency(item.depositAmount)),
                ticketPrice: (react_1.default.createElement("span", null, formatCurrency(Number((settingsPerCurrency === null || settingsPerCurrency === void 0 ? void 0 : settingsPerCurrency.price) || 1)))),
                ticketsEarned: (react_1.default.createElement("span", null, Math.floor(Number(item.depositAmount) /
                    Number((settingsPerCurrency === null || settingsPerCurrency === void 0 ? void 0 : settingsPerCurrency.price) || 1)))),
            };
        });
        return table;
    }, [preparedHistory, t, formatCurrency, settingsPerCurrency]);
};
exports.useTableData = useTableData;
